import React, { useState } from 'react';
import './ImagePlaceholder.css';

/**
 * Componente de imagen con placeholder
 * @param {string} src - URL de la imagen (opcional)
 * @param {string} alt - Texto alternativo
 * @param {string} aspectRatio - Ratio de aspecto (ej: '16/9', '4/3', '1/1')
 * @param {string} icon - Emoji o icono para el placeholder
 * @param {string} className - Clases CSS adicionales
 */
const ImagePlaceholder = ({
    src,
    alt = 'Imagen',
    aspectRatio = '16/9',
    icon = '📷',
    className = ''
}) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    const showPlaceholder = !src || imageError || !imageLoaded;

    return (
        <div
            className={`image-placeholder ${className}`}
            style={{ aspectRatio }}
        >
            {showPlaceholder && (
                <div className="image-placeholder__content">
                    <span className="image-placeholder__icon">{icon}</span>
                    <span className="image-placeholder__text">Imagen próximamente</span>
                </div>
            )}
            {src && (
                <img
                    src={src}
                    alt={alt}
                    className={`image-placeholder__img ${imageLoaded ? 'image-placeholder__img--loaded' : ''}`}
                    onLoad={() => setImageLoaded(true)}
                    onError={() => setImageError(true)}
                />
            )}
        </div>
    );
};

export default ImagePlaceholder;
